import styled, {css} from 'styled-components';
import {device} from 'styled/device';
import Select from '../../../components/Select';

export const OrderForm = styled.div`
  background-color: #fcfcfd;
  border: 1px solid #e6e8ec;
  border-radius: 24px;
  color: #23262f;
  padding: 50px 0;

  .moreDates {
    display: flex;
    justify-content: center;
    color: #23262f;
    font-weight: 500;
    font-size: 16px;
    padding: 40px 0;
  }

  @media (max-width: ${device.mobileM}) {
    padding: 40px 0;
    box-shadow: 0 64px 64px #0f0f0f14;

    .moreDates {
      font-weight: 500;
      font-size: 18px;
      padding: 40px 0;
    }
  }
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;

  .scheduleDate {
    color: #23262f;
    font-weight: 500;
    font-size: 16px;
  }

  .scheduleTime {
    color: #777e90;
    font-weight: 400;
    font-size: 12px;
  }

  .subTitle {
    color: #23262f;
    font-weight: 500;
    font-size: 32px;
    padding-bottom: 30px;
  }

  .text18 {
    color: #777e91;
    font-weight: 400;
    font-size: 18px;
    display: flex;
  }

  @media (max-width: ${device.mobileM}) {
    .subTitle {
      font-size: 24px;
    }

    .scheduleDate {
      font-size: 18px;
    }

    .scheduleTime {
      font-size: 14px;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const OrderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-bottom: 1px solid #e6e8ec;
  padding: 20px 40px;

  .rowName {
    font-size: 19px;
    font-weight: 600;
  }

  .rowValue {
    display: flex;
    align-items: center;

    .control-wrapper {
      margin-bottom: 0;
    }

    .newPrice {
      font-size: 20px;
      font-weight: 700;
    }

    .unitType {
      color: #b1b5c4;
      font-weight: 400;
      font-size: 16px;
      text-transform: lowercase;
    }
  }

  @media (max-width: ${device.mobileM}) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 10px;
  }
`;

export const TotalPriceRow = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #e5e5eb;
  align-items: center;
  padding: 20px 40px;
  margin-top: 20px;
  width: inherit;

  .rowName {
    font-size: 19px;
    font-weight: 600;
  }

  .priceValue {
    font-size: 32px;
    font-weight: 700;
    letter-spacing: -0.32px;
  }

  @media (max-width: ${device.mobileM}) {
    margin-top: 1rem;
    padding: 20px 24px;
    width: inherit;
  }
`;

export const OrderCol = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e6e8ec;
  padding: 20px 0;

  .rowName {
    font-size: 19px;
    font-weight: 600;
  }
`;

export const MultiPriceItem = styled.div<{isSelected?: boolean}>`
  border: 0;
  padding: 2px 12px;

  ${props =>
    props.isSelected &&
    css`
      background-color: #f5f5fa;
      border: 0;

      .itemName {
        font-weight: 600;
      }
    `};

  .itemCheckbox {
    min-width: fit-content;
    cursor: grab;

    span > div:nth-child(1) {
      /* background: red; */
      height: 100px;
    }
  }

  .itemCheckbox > div > div > div:first-child {
    /* height: 24px; */
    /* background: green; */
  }

  @media (max-width: ${device.mobileM}) {
    .itemCheckbox {
      display: flex;
      justify-content: center;
      width: 30px;

      span {
        width: 100%;
      }
    }
  }
`;

export const PriceItemRow = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  padding: 20px 0;
  width: 100%;

  .itemName {
    align-items: center;
    display: flex;
    word-break: break-all;
    padding-left: 5px;
    margin-right: 5px;
  }

  .itemParams {
    display: flex;
    gap: 5px;
  }

  .rightPriceItemPart {
    display: flex;
    gap: 20px;
    min-width: 60%;
  }

  .leftPriceItemPart {
    display: flex;
    gap: 5px;
    min-width: 40%;
  }

  .itemCounter {
    display: flex;
    align-items: center;

    & > div {
      height: 42px;
      width: 100px;
      & .counter-content-value {
        font-size: 16px;
      }
    }
  }

  .smallCounter {
    height: 42px;
    width: 98px;
    padding: 0 8px;

    div {
      font-size: 16px;
    }
  }

  .rowValue {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    max-width: 155px;

    .newPrice {
      font-size: 20px;
      font-weight: 700;
    }

    .unitType {
      color: #b1b5c4;
      font-weight: 400;
      font-size: 16px;
      text-transform: lowercase;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        text-overflow: initial;
        overflow: initial;
      }
    }
  }

  @media (max-width: ${device.mobileXL}) {
    flex-direction: column;
    align-items: flex-start;
    row-gap: 13px;

    .leftPriceItemPart {
      display: flex;
      gap: 5px;
      min-width: auto;
    }
    .rightPriceItemPart {
      padding-left: 30px;
      justify-content: space-around;
      width: 100%;
    }
    .rowValue {
      min-width: fit-content;
    }
  }

  @media (max-width: ${device.mobileM}) {
    .rightPriceItemPart {
      padding: 0;
      gap: 10px;
    }
  }

  @media (max-width: ${device.mobileS}) {
    .rowValue {
      flex-direction: column;
    }
  }
`;

export const SelectTime = styled(Select)`
  & .select__control,
  & .select__control:hover {
    border: 2px solid #e6e8ec;
  }
`;
